const END_MONTH_YEARS_AHEAD = 10;

/**
 * Computes the latest month the calendar can navigate to: ten years after
 * the selected date (or today when nothing is selected).
 *
 * Required whenever the calendar uses `captionLayout="dropdown"`: without an
 * explicit `endMonth`, react-day-picker caps navigation at the end of the
 * current year.
 *
 * @param selectedFrom - the currently selected (from) date, if any
 * @returns the end-month boundary for the calendar
 */
export const computeEndMonth = (selectedFrom: Date | null): Date => {
  const reference = selectedFrom ?? new Date();
  return new Date(reference.getFullYear() + END_MONTH_YEARS_AHEAD, 0);
};
